import React from "react";
import locale from "@bonliva-crm/locale";
import { Color } from "@bonliva-crm/ui";
import { Table, TableCell, TableHead, TableRow, makeStyles } from "@material-ui/core";
import { Text } from "@common/formx";
import { TravelZoneData } from "../CustomerContractPriceListFormData";

type Props = {
  items: TravelZoneData[];
};

export function TravelZoneTable(props: Props) {
  const classes = useClasses();

  return (
    <Table size="small" classes={{ root: classes.root }}>
      <TableHead>
        <TableRow>
          <TableCell>{locale.name}</TableCell>
          <TableCell width="5rem">{locale.articleNumber}</TableCell>
        </TableRow>
      </TableHead>

      {props.items.map((zone, i) => (
        <TableRow>
          <TableCell>{zone.label}</TableCell>

          <TableCell>
            <Text
              name={`travelZones[${i}].articleNumber`}
              TextFieldProps={{ fullWidth: true }}
            />
          </TableCell>
        </TableRow>
      ))}
    </Table>
  );
}

const useClasses = makeStyles({
  root: {
    borderRadius: 8,

    "& th": {
      backgroundColor: Color.LightGray
    },
    "& td": {
      backgroundColor: "rgba(245,245,245,0.76)"
    }
  }
});
